import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useSyncExternalStore } from "react";
import { geomapStore } from "../../geomapStore";
export const GeomapContext = React.createContext(null);
export const GeomapContextProvider = ({ children }) => {
    const state = useSyncExternalStore(geomapStore.subscribe, geomapStore.getState);
    return _jsx(GeomapContext.Provider, { value: state, children: children });
};
export const useGeomapContext = () => {
    const value = React.useContext(GeomapContext);
    if (value === null) {
        throw new Error("useGeomapContext must be used within a GeomapContextProvider");
    }
    return value;
};
export const useGeomapConfig = () => {
    return useGeomapContext().geomapConfig;
};
export const useGeomaps = (geomapId, filterGroups) => {
    const geomaps = useGeomapContext().geomaps;
    return useMemo(() => filterGroups.length === 0
        ? []
        : geomaps.filter((geomap) => geomap.properties.geomapId === geomapId &&
            geomap.properties.allFilterGroups.some((group) => filterGroups.includes(group))), [geomaps, filterGroups, geomapId]);
};
export const useSAAMaps = (geomapId) => {
    const geomaps = useGeomapContext().saaGeomaps;
    return geomaps;
    // return useMemo(() => geomaps.filter((geomap) => geomap.properties.geomapId === geomapId), [geomaps, geomapId]);
};
export const useFilterMenuButton = (pos) => {
    return useGeomapContext().mapFilterMenu.buttons.find((button) => button.menuPosition === pos);
};
export const useBCGs = () => {
    return useGeomapContext().bcg.buttons;
};
//# sourceMappingURL=geomapContext.js.map